import React from 'react';
import i18n from 'i18next';
import _ from 'lodash';

const { Order } = Mobi2Go;

class OrderTaxes extends React.Component {
    constructor() {
        super();

        this.state = {
            tax_totals: Order.getTaxTotals(),
            should_display: Order.shouldDisplayTaxExclusivePrices(),
        };

        Order.bind({
            updateTaxTotals: this.updateTaxTotals,
            updateLocation: () =>
                this.setState({
                    should_display: Order.shouldDisplayTaxExclusivePrices(),
                }),
        });
    }

    updateTaxTotals = new_tax_totals => {
        const tax_totals = _.filter(
            new_tax_totals,
            tax => tax.total.toFloat() > 0
        );
        this.setState({ tax_totals });
    };

    render() {
        if (!this.state.should_display) {
            return null;
        }

        return (
            <div>
                {this.state.tax_totals.map((tax, i) => (
                    <div
                        className="m2g-order-item m2g-order-item--indented m2g-order-tax-item"
                        key={i}
                    >
                        <span className="m2g-order-tax-item-name">
                            {tax.name}
                        </span>
                        <span className="m2g-order-item-price m2g-order-tax-item-amount">
                            {i18n.t('common:price', {
                                price: tax.total,
                            })}
                        </span>
                    </div>
                ))}
            </div>
        );
    }
}

export default OrderTaxes;
